/* eslint-disable jsx-a11y/iframe-has-title */
import React from "react";
import EndCheckout from "./Integrations/EndCheckout";
import Fulfillment from "./Integrations/Fulfillment";
import Gateway from "./Integrations/Gateway";
import SaleFunnel from "./Integrations/SaleFunnel";

const Integration = () => {
  return (
    <div style={{ marginTop: "10px" }} className="integration-page">
      <EndCheckout />
      <Gateway />
      <SaleFunnel />
      <Fulfillment />
    </div>
  );
};

export default Integration;
